import React from "react";
import { motion } from "framer-motion";

const LoadingCircle = ({ size = "md", fullPage = false }) => {
  // Mapping ukuran
  const sizes = {
    sm: "w-5 h-5 border-2",
    md: "w-10 h-10 border-4",
    lg: "w-16 h-16 border-[6px]",
  };

  const spinner = (
    <div className="relative flex items-center justify-center">
      {/* Lingkaran Background (Sangat Transparan) */}
      <div className={`${sizes[size]} rounded-full border-white/10`} />
      
      {/* Lingkaran yang Berputar */}
      <motion.div
        animate={{ rotate: 360 }}
        transition={{
          repeat: Infinity,
          duration: 1,
          ease: "linear",
        }}
        className={`absolute ${sizes[size]} rounded-full border-t-[#00df9a] border-r-transparent border-b-transparent border-l-transparent`}
      />
    </div>
  );

  if (fullPage) {
    return (
      <div className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0F172A]">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingCircle;